<template>
  <div class="flexwrap centercenter" id="popupmain" @click.self="$emit('close', true)">
    <transition name="slidefade" appear>
      <div id="popup_body" class="plainStandardTheme mediumRoundAngles bigShadow withBorder"
           :style="styleObject" :key="1" >
        <div class="close clickable">
          <i class="fas fa-times" @click="$emit('close', true)"></i>

        </div>
        <slot></slot>
      </div>
    </transition>
  </div>

</template>

<script>
import {mapActions, mapGetters} from "vuex";

export default {
  name: "popup",
  props:["height", "width"],
  computed: {
    ...mapGetters('global', [
        'isMobile',
      'popupOpened',
    ]),
    styleObject: function () {
      return {
        '--height': this.height,
        '--width': this.width,
      }
    },},
  methods: {
    ...mapActions('global', [
      'set_popupOpened',
    ]),
  }
}
</script>

<style scoped>

#popupmain{
  position: absolute;
  top:0;
  left:0;
  z-index: 100;
  height: 100%;
  width: 100%;
  background-color: #00000033;
  backdrop-filter: blur(0.1vw);
}

  #popup_body{
    z-index: 101;
    position: relative;
    width: var(--width);
    height: var(--height);
    padding: 1.5vw;
    /* permet d'aligner les div verticalement */
    display: flex;
    font-family: 'Open Sans', Helvetica, Arial, sans-serif;
    /*opacity: 0.98;*/
  }
  #popup_body:focus{
    outline: none;
  }
  .close {
    position: absolute;
    top: 0.25vw;
    right: 0.5vw;
    font-size: 1.5vw;
  }


  @media screen and (max-device-width: 767px) {
    #popupmain{
      backdrop-filter: blur(0.5vw);
    }
    #popup_body {
      font-size: 4vw;
    }
    .close {
      top: 2vw;
      right: 4vw;
      font-size: 5vw;
    }

  }
</style>